export const BACKGROUND_JOB_IDS = {
  CATEGORY_CHECK: 'work-order-category-check',
  DEDUPLICATION: 'work-order-deduplication',
  CANDIDATES_SEARCH: 'work-notifications-candidates-search',
  PRIORITY_CHECK: 'priorization-check'
} as const;

export enum BackgroundJobType {
  CATEGORY = 'category',
  DUPLICATES = 'duplicates',
  SEARCH = 'search',
  PRIORITY = 'priority'
}
